import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { clearSectionDocumentsFromStore, getDocumentsBySectionId } from 'actions/documents';
import { getFileUrl } from 'actions/files';
import { clearSectionPostsFromStore, getPostsBySectionId } from 'actions/posts';
import { fetch_preschoolgoals } from 'actions/preschoolform';
import LoadingCards from 'components/Cards/LoadingCard';
import Date from 'components/Presentation/Date/Date';
import SectionTitle from 'components/Presentation/SectionTitle';
import { PRESCHOOL } from 'constants/schoolTypes';
import Documentation from 'containers/Forms/Documentation';
import Post from 'containers/Forms/Post';
import Modal from 'containers/Modals/Modal';
import { objectsAreSame } from 'helpers/array';
import { isUserTeacher } from 'helpers/user';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Block, { BlockWrapper } from 'UI/Elements/Block';
import { Button, Icon, TooltipMenu } from '@haldor/ui';
import FromNow from 'components/Presentation/Date/FromNow';

var SectionPosts = /*#__PURE__*/function (_Component) {
  _inherits(SectionPosts, _Component);

  var _super = _createSuper(SectionPosts);

  function SectionPosts(props) {
    var _this;

    _classCallCheck(this, SectionPosts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var currentLength = _this.state.currentLength;

      if (!objectsAreSame(nextProps.combined, _this.props.combined)) {
        // Only check if the combined has changed
        var received = nextProps.combined.length - currentLength;

        if (received < 14) {
          _this.setState({
            limitReached: true,
            currentLength: nextProps.combined.length
          });
        } else {
          _this.setState({
            limitReached: false,
            currentLength: nextProps.combined.length
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearSectionDocumentsFromStore();

      _this.props.clearSectionPostsFromStore();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var isPreschool = false;

      if (_this.props.currentUser.schools.getActiveSchool(_this.props.currentUser.userId).type == PRESCHOOL) {
        isPreschool = true;
      }

      if (isPreschool) {
        _this.setState({
          loadingDocuments: true
        });

        _this.props.clearSectionDocumentsFromStore();

        _this.props.getDocumentsBySectionId(_this.props.groupid, 1).then(function () {
          _this.setState({
            loadingDocuments: false
          });
        });

        if (_this.props.preschoolGoals.length < 1) {
          _this.props.fetch_preschoolgoals();
        }
      }

      _this.setState({
        loadingPosts: true
      });

      _this.props.clearSectionPostsFromStore();

      _this.props.getPostsBySectionId(_this.props.groupid, 1).then(function () {
        _this.setState({
          loadingPosts: false
        });
      });

      if (_this.props.combined.length > 0) {
        _this.setState({
          currentLength: _this.props.combined.length
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDocumentModal", function () {
      _this.setState({
        documentModal: !_this.state.documentModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEventModal", function () {
      _this.setState({
        eventModal: !_this.state.eventModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSectionContent", function () {
      var _this$props = _this.props,
          combined = _this$props.combined,
          limit = _this$props.limit;

      if (combined.length > 0) {
        return /*#__PURE__*/React.createElement(BlockWrapper, {
          cols: limit ? 3 : 1
        }, combined ? combined.map(function (document, index) {
          if (limit) {
            if (index < limit) {
              return _this.renderDocument(document);
            } else {
              return null;
            }
          }

          return _this.renderDocument(document);
        }) : null);
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "color--meta weight--bold text--center"
        }, _this.props.translate('no-items-found'));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "headerContent", function (document) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }, document.author != null ? typeof document.author == 'string' ? document.author : "".concat(document.author.firstName != null ? document.author.firstName : '', " ").concat(document.author.lastName != null ? document.author.lastName : '') : ' '), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, document.published != null ? Moment.utc(document.published).isAfter(Moment()) ? /*#__PURE__*/React.createElement(FromNow, null, Moment.utc(document.published).local().format()) : /*#__PURE__*/React.createElement(Date, null, Moment.utc(document.published).local()) : null), document.status == 'POST_DRAFT' || document.status == 'DOCUMENTATION_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right',
          marginRight: 8
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontSize: '0.9em'
        }
      }, _this.props.translate('Draft'))) : null, document.important && document.eventDate != null && Moment() <= Moment(document.eventDate) ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontSize: '0.9em',
          marginRight: '8px'
        }
      }, _this.props.translate('important!'))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "content", function (document) {
      if (document.ReferenceType == 'post') {
        var strippedDescription = document.body.replace(/(<([^>]+)>)/ig, '');

        if (strippedDescription.length > 99) {
          strippedDescription = strippedDescription.slice(0, 100) + '…';
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
          style: {
            fontSize: '1.25em'
          }
        }, document.title), /*#__PURE__*/React.createElement("p", {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          dangerouslySetInnerHTML: {
            __html: strippedDescription
          }
        }));
      } else {
        var _strippedDescription = '';

        if (document.description != null) {
          _strippedDescription = document.description.replace(/(<([^>]+)>)/ig, '');

          if (_strippedDescription.length > 99) {
            _strippedDescription = _strippedDescription.slice(0, 100) + '…';
          }
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
          style: {
            fontSize: '1.25em'
          }
        }, document.title), /*#__PURE__*/React.createElement("p", {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          dangerouslySetInnerHTML: {
            __html: _strippedDescription
          }
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "footerContent", function (document) {
      var preschoolGoals = _this.props.preschoolGoals;

      if (document.associatedGoals && document.associatedGoals.length > 0) {
        var groups = [];

        if (preschoolGoals && preschoolGoals.length > 0) {
          preschoolGoals.map(function (goal) {
            var inDocument = document.associatedGoals.find(function (goalOb) {
              return goalOb.goalId == goal.id;
            });

            if (typeof inDocument != 'undefined') {
              var inArray = groups.findIndex(function (i) {
                return i.name == goal.group;
              });

              if (inArray > -1) {
                return groups[inArray].count++;
              } else {
                var group = {
                  'name': goal.group,
                  'color': goal.colorCode,
                  'count': 1
                };
                return groups.push(group);
              }
            }
          });
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, _this.props.translate('goals')), groups.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "goal-preview-container"
        }, groups.map(function (group) {
          return /*#__PURE__*/React.createElement("div", {
            key: "goal-" + group.name,
            className: "goal-preview",
            style: {
              backgroundColor: group.color
            }
          }, group.name, " (", group.count, ")");
        })) : null);
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDocument", function (document) {
      var important = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var link = '';

      if (document.ReferenceType == 'post') {
        link = '/post/' + document.id;
      } else {
        link = '/preschooldocument/' + document.id;
      }

      var expireDate = Moment(document.validUntil).hour(23).minute(59);

      if (document.validUntil != null && expireDate.diff(Moment()) < 0) {
        return null;
      }

      if (!important && document.important && document.ReferenceType == "post" && Moment().isSameOrAfter(Moment(document.published), 'day') && Moment(document.eventDate).isSameOrAfter(Moment(), 'day') && Moment().isSameOrAfter(Moment(document.eventDate).subtract(7, "days"), 'day')) {
        return null;
      }

      var file = null;

      if (document.associatedFiles != null && document.associatedFiles.length > 0) {
        file = document.associatedFiles.find(function (file) {
          return file.type.indexOf('image') > -1;
        });
      }

      return /*#__PURE__*/React.createElement(Block, {
        key: document.ReferenceType + '-' + document.id,
        headerContent: _this.headerContent(document),
        image: file,
        content: _this.content(document),
        footerContent: _this.footerContent(document),
        link: link
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCreateButton", function () {
      if (_this.props.disableCreate) {
        return null;
      }

      var isPreschool = false;

      if (_this.props.currentUser.schools.getActiveSchool(_this.props.currentUser.userId).type == PRESCHOOL) {
        isPreschool = true;
      }

      var isTeacher = isUserTeacher(_this.props.currentUser);

      if (isTeacher) {
        if (isPreschool) {
          return /*#__PURE__*/React.createElement("div", {
            className: "create-container",
            style: {
              display: 'inline-block'
            }
          }, /*#__PURE__*/React.createElement(TooltipMenu, {
            trigger: /*#__PURE__*/React.createElement(Button, {
              type: "secondary"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Plus"
            }), " ", _this.props.translate('Create'))
          }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: _this.toggleDocumentModal
          }, _this.props.translate('create-new-documentation')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            onClick: _this.toggleEventModal
          }, _this.props.translate('create-new-post'))));
        }

        return /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.toggleEventModal
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Plus"
        }), " ", _this.props.translate('Create'));
      } else {
        return null;
      }
    });

    _this.state = {
      documentModal: false,
      eventModal: false,
      loadingDocuments: false,
      loadingPosts: false,
      appending: false,
      limitReached: false,
      currentLength: 0
    };
    return _this;
  }

  _createClass(SectionPosts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          loadingDocuments = _this$state.loadingDocuments,
          loadingPosts = _this$state.loadingPosts,
          appending = _this$state.appending,
          limitReached = _this$state.limitReached;
      var _this$props2 = this.props,
          combined = _this$props2.combined,
          documents = _this$props2.documents,
          userRole = _this$props2.userRole,
          limit = _this$props2.limit,
          groups = _this$props2.groups;
      var isPreschool = false;

      if (this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type == PRESCHOOL) {
        isPreschool = true;
      }

      var isTeacher = isUserTeacher(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "preschooldocuments"
      }, isTeacher && isPreschool ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.documentModal,
        onClose: this.toggleDocumentModal,
        title: this.props.translate('create-new-documentation')
      }, /*#__PURE__*/React.createElement(Documentation, {
        onModalClose: this.toggleDocumentModal
      })) : null, isTeacher ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.eventModal,
        onClose: this.toggleEventModal,
        title: this.props.translate('create-new-post')
      }, /*#__PURE__*/React.createElement(Post, {
        section: this.props.group,
        onModalClose: this.toggleEventModal
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section"
      }, limit != false && this.props.combined.find(function (post) {
        return post.important && post.ReferenceType == "post" && Moment().isSameOrAfter(Moment(post.published), 'day') && Moment(post.eventDate).isSameOrAfter(Moment(), 'day') && Moment().isSameOrAfter(Moment(post.eventDate).subtract(7, "days"), 'day');
      }) != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('important-posts'))), /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: limit ? 3 : 1
      }, this.props.combined.map(function (post) {
        var SevenDaysAgo = Moment(post.eventDate).subtract(7, "days");

        if (post.important && post.ReferenceType == "post" && Moment().isSameOrAfter(Moment(post.published), 'day') && Moment(post.eventDate).isSameOrAfter(Moment(), 'day') && Moment().isSameOrAfter(SevenDaysAgo, 'day')) {
          return _this2.renderDocument(post, true);
        }
      }))) : null, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Post"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate('preschooldocument-posts')), limit ? this.renderCreateButton() : null, limit ? /*#__PURE__*/React.createElement(Link, {
        to: "/posts?group=".concat(this.props.groupid),
        className: "see-more"
      }, this.props.translate('show-all-posts')) : null)), /*#__PURE__*/React.createElement("div", {
        className: "posts-section-container"
      }, !limit ? /*#__PURE__*/React.createElement("div", {
        className: "posts-content"
      }, loadingDocuments || loadingPosts ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : this.renderSectionContent()) : /*#__PURE__*/React.createElement("div", null, loadingDocuments || loadingPosts ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : this.renderSectionContent()), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })));
    }
  }]);

  return SectionPosts;
}(Component);

_defineProperty(SectionPosts, "defaultProps", {
  limit: 3
});

function mapStateToProps(state) {
  return {
    user: state.user.user,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    preschoolGoals: state.PreschoolGoals.preschoolGoals,
    groups: state.sections.educationGroups,
    documents: state.Documents.sectionDocuments,
    posts: state.Posts.sectionPosts,
    combined: state.CombinedEvents.sectionCombined,
    group: state.sections.activeSection
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getDocumentsBySectionId: getDocumentsBySectionId,
    getPostsBySectionId: getPostsBySectionId,
    getFileUrl: getFileUrl,
    fetch_preschoolgoals: fetch_preschoolgoals,
    clearSectionDocumentsFromStore: clearSectionDocumentsFromStore,
    clearSectionPostsFromStore: clearSectionPostsFromStore
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionPosts);